import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { FlaskConical, ArrowRight } from 'lucide-react'
import type { RootState } from '../store'
import { useNavigate } from './nav'
import { useGetProjectQuery } from '../services/projectDataApi'
import './ShareCtaBanner.css'

// Shown along the very top of the viewport when a logged-OUT visitor is viewing a shared (public)
// project — i.e. they arrived via a project share link (ShareDialog links to /projects/:id/overview,
// which only renders for outsiders when the project is_public). Invites them to test their own apps
// with Replay QA. Renders nothing for signed-in users, before the auth check resolves, or on any
// non-public view. Placed at the top of AppShell so it spans the full width above the sidebar + content.
export default function ShareCtaBanner() {
  const navigate = useNavigate()
  const { projectId } = useParams<{ projectId: string }>()
  const user = useSelector((s: RootState) => s.auth.user)
  const authChecked = useSelector((s: RootState) => s.auth.checked)
  const projectQuery = useGetProjectQuery(projectId ?? '', { skip: !projectId })
  const isPublicProject = projectQuery.data?.is_public === true

  if (!authChecked || user || !isPublicProject) return null

  return (
    <div className="share-cta-banner" role="region" aria-label="Get started with Replay QA" data-testid="share-cta-banner">
      <span className="share-cta-banner__text">
        <FlaskConical size={16} aria-hidden className="share-cta-banner__icon" />
        Like what you see? <strong>Test your own apps with Replay QA</strong> — automated QA that finds real bugs.
      </span>
      <button
        type="button"
        className="share-cta-banner__btn"
        onClick={() => navigate('/new')}
        data-testid="share-cta-get-started"
        data-analytics-event="share-cta-get-started"
      >
        Get started free
        <ArrowRight size={15} aria-hidden />
      </button>
    </div>
  )
}
